import { denormalize } from 'normalizr';
import { sort } from 'ramda';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';

import { createAlphabeticalComparator } from 'utils/helpers';

import { types } from './actions';
import { addOnDefSchema } from './entities';

const initialState = {
  addOnDefIds: [],
  entities: {},
  isCreating: false,
  isCreateModalOpen: false,
};

const entitiesReducer = createEntitiesReducer(
  ['addOnDefs'],
  [types.CREATE_ADD_ON_SUCCESS, types.RECEIVE_ADD_ON_DEFINITIONS],
);

const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.CREATE_ADD_ON_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case types.CREATE_ADD_ON_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case types.CREATE_ADD_ON_SUCCESS:
      return {
        ...state,
        addOnDefIds: [...state.addOnDefIds, payload.result],
        isCreating: false,
        isCreateModalOpen: false,
      };
    case types.NEW_ADD_ON_MODAL_CLOSE:
      return {
        ...state,
        isCreateModalOpen: false,
      };
    case types.NEW_ADD_ON_MODAL_OPEN:
      return {
        ...state,
        isCreateModalOpen: true,
      };
    case types.RECEIVE_ADD_ON_DEFINITIONS:
      return {
        ...state,
        addOnDefIds: payload.result,
      };
    default:
      return state;
  }
};

export default reduceReducers(entitiesReducer, reducer, initialState);

export const getScope = (state) => state.modules.addOns.listPage;

export const getIsCreating = (state) => getScope(state).isCreating;

export const getIsCreateModalOpen = (state) =>
  getScope(state).isCreateModalOpen;

export const getAddOnDefs = (state) => {
  const denormalizedAddOnDefs = denormalize(
    getScope(state).addOnDefIds,
    [addOnDefSchema],
    getScope(state).entities,
  );
  return sort(createAlphabeticalComparator('name'), denormalizedAddOnDefs);
};

export const isCreating = (state) => getScope(state).isCreating;

export const isCreateModalOpen = (state) => getScope(state).isCreateModalOpen;
